import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { EditCountryIcon } from "../../../assets";
import { ERROR_TOAST } from "../../../constants/toast.constants";
import { EMPTY_STRING, termsAndConditionsConstants } from "../../../constants";
import { customToast, isEditorEmpty } from "../../../shared/utility";
import MainSpinner from "../../../shared/components/spinner/MainSpinner";
import RoundedButton from "../../../shared/components/buttons/RoundedButton";
import RichTextEditor from "../../../shared/components/editor/RichTextEditor";
import convertContentToHTML from "../../../shared/utility-functions/ConvertContentToHtml";
import MainContentWrapper from "../../../shared/components/main-content-wrapper/MainContentWrapper";
import { termsAndConditionsActions } from "../../../redux/actions";

const { GET_TERMS_AND_CONDITIONS } = termsAndConditionsConstants;

const AdminTermsAndConditions = ({
  getTermsAndConditions,
  termsAndConditions,
  spinnerActions,
  addOrUpdateTermsAndConditions,
}) => {
  const [content, setContent] = useState(EMPTY_STRING);
  const [htmlContent, setHtmlContent] = useState(EMPTY_STRING);

  const [isEditing, setIsEditing] = useState(false);

  const handleContentChange = (newContent) => {
    setContent(newContent);
  };

  const spinner = useCallback(
    (type) => {
      return spinnerActions.findIndex((s) => s === type);
    },
    // eslint-disable-next-line
    [spinnerActions]
  );

  const handleSave = () => {
    if (isEditorEmpty(content)) {
      customToast("Terms and conditions must not be empty", ERROR_TOAST);
      return;
    }
    addOrUpdateTermsAndConditions({ ...termsAndConditions, content }, () => {
      setIsEditing(false);
      getTermsAndConditions();
    });
  };

  useEffect(() => {
    if (termsAndConditions?.content) {
      const html = convertContentToHTML(termsAndConditions.content);
      setHtmlContent(html);
    }
  }, [termsAndConditions]);

  useEffect(() => {
    getTermsAndConditions();

    // eslint-disable-next-line
  }, []);

  return (
    <MainContentWrapper>
      {spinner(GET_TERMS_AND_CONDITIONS) > -1 && (
        <MainSpinner className="admin-spinner" />
      )}
      <div className="d-flex align-items-center justify-content-between">
        <div className="admin-page-heading">Terms and Conditions</div>
        {!isEditing && (
          <div
            className="d-flex justify-content-end align-items-center gap-1 pointer"
            onClick={() => setIsEditing(true)}
          >
            <img
              src={EditCountryIcon}
              className="edit-country-info-image"
              alt="Edit"
            />
            <div className="edit-country-info-text">Edit</div>
          </div>
        )}
      </div>
      {spinner(GET_TERMS_AND_CONDITIONS) === -1 && (
        <>
          {isEditing && (
            <>
              <RichTextEditor
                onContentChange={handleContentChange}
                initialContent={termsAndConditions?.content ?? EMPTY_STRING}
              />
              <div className="agent-approval-buttons-container d-flex justify-content-center gap-3 mt-5">
                <RoundedButton onClick={handleSave}>Update</RoundedButton>
                <RoundedButton
                  type="button"
                  className="reject-button reject-button-outlined"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </RoundedButton>
              </div>
            </>
          )}
          {!isEditing && (
            <div
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              className="html-content"
            />
          )}
        </>
      )}
    </MainContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  termsAndConditions: state.termsAndConditionsReducer.termsAndConditions,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  getTermsAndConditions: () =>
    dispatch(termsAndConditionsActions.getTermsAndConditions()),
  addOrUpdateTermsAndConditions: (data, func) =>
    dispatch(
      termsAndConditionsActions.addOrUpdateTermsAndConditions(data, func)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminTermsAndConditions);
